<template>
  <div class="main">
    <base-card v-for="beverage in beverages" :key="beverage.name">
      <v-card-title class="flex text-left">{{ beverage.name }}</v-card-title>
      <v-card-actions class="flex text-left">
        {{ beverage.bottleS }} <br />
        {{ beverage.bottleL }}
        <v-spacer></v-spacer>
        {{ beverage.priceS }} <br />
        {{ beverage.priceL }}
      </v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      beverages: [
        {
          name: "Кока Кола",
          bottleS: "0.33л",
          bottleL: "0.45л",
          priceS: "60 ден.",
          priceL: "70 ден.",
        },
        {
          name: "Кока Кола Зеро",
          bottleS: "0.33л",
          bottleL: "0.45л",
          priceS: "60 ден.",
          priceL: "70 ден.",
        },
        {
          name: "Фанта",
          bottleS: "0.33л",
          bottleL: "0.45л",
          priceS: "60 ден.",
          priceL: "70 ден.",
        },
        {
          name: "Спрајт",
          bottleS: "0.33л",
          bottleL: "0.45л",
          priceS: "60 ден.",
          priceL: "70 ден.",
        },
        {
          name: "Швепс Битер",
          bottleS: "0.33л",
          bottleL: "0.5л",
          priceS: "60 ден.",
          priceL: "70 ден.",
        },
        {
          name: "Роса",
          bottleS: "",
          bottleL: "0.5л",
          priceS: "",
          priceL: "50 ден.",
        },
        {
          name: "Лeден чај праска",
          bottleS: "0.3л",
          bottleL: "0.33л",
          priceS: "40 ден.",
          priceL: "50 ден.",
        },
        {
          name: "Лимонада",
          bottleS: "0.3л",
          bottleL: "0.33л",
          priceS: "40 ден.",
          priceL: "50 ден.",
        },
        {
          name: "Боровница",
          bottleS: "0.3л",
          bottleL: "0.33л",
          priceS: "40 ден.",
          priceL: "50 ден.",
        },
        {
          name: "Малина",
          bottleS: "0.3л",
          bottleL: "0.33л",
          priceS: "40 ден.",
          priceL: "50 ден.",
        },
        {
          name: "Турско кафе",
          bottleS: "",
          bottleL: "",
          priceS: "60 ден.",
          priceL: "",
        },
        {
          name: "3 во 1",
          bottleS: "",
          bottleL: "",
          priceS: "60 ден.",
          priceL: "",
        },
        {
          name: "Нес Кафе",
          bottleS: "",
          bottleL: "",
          priceS: "",
          priceL: "80 ден.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 180vh;
  background: transparent;
}
</style>
